import { render, staticRenderFns } from "./HeaderBar.vue?vue&type=template&id=51d3c87a&scoped=true&"
import script from "./HeaderBar.vue?vue&type=script&lang=js&"
export * from "./HeaderBar.vue?vue&type=script&lang=js&"
import style0 from "./HeaderBar.vue?vue&type=style&index=0&id=51d3c87a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d3c87a",
  null
  
)

export default component.exports